import React from 'react';
import {components, DropdownIndicatorProps} from 'react-select';
import Icon from 'shared/Icon';
import styled from 'styled-components';

// eslint-disable-next-line require-jsdoc -- no need for ts
export function CustomDropdownIndicator<T>(
    props: DropdownIndicatorProps<T, false>
) {
    return (
        <components.DropdownIndicator {...props}>
            <Image iconName="search-primary.svg" showAltText={false} />
        </components.DropdownIndicator>
    );
}

const Image = styled(Icon)`
    width: 20px !important;
    cursor: pointer;
`;
